var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.size !== 'size-mini')?_c('div',{staticClass:"artwork-meta",class:( _obj = {}, _obj[_vm.size] = _vm.size, _obj )},[_c('Artwork'),_vm._v(" "),_c('MetaInfo')],1):_vm._e()
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }